import styled from 'styled-components';

export const FilterBarZone = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 2.5rem;
  margin-top: 1.125rem;
  padding-top: 1px;
`;

export const Separator = styled.div`
  height: 60%;
  width: 1px;
  background-color: lightgray;
`;

export const AreaIcon = styled.div`
  display: flex;
  padding: 0.1rem 0rem 0rem 0rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 2.5rem;
  height: 2.27rem;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${({ checked }) => (checked ? '#cbd5e1' : 'transparent')};
  &:hover > svg {
    transform: ${(props) => {
      return props?.isFix ? 'scale(1);' : 'scale(1.2);';
    }};
  }
`;

export const LabelCount = styled.span`
  font-size: 8pt;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 2.5rem;
  margin-bottom: 0.22rem;

  @media (max-width: 768px) {
    max-width: 2rem;
  }
`;
